module.exports = __webpack_public_path__ + "img/CN.f38a8f47.svg";